import { NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { PrintfileReportDetail } from '@app/file-api/file-api.service';
import { GetTextPipe } from '@app/shared/utils/i18n.service';

/** Component to display printfile report messages. */
@Component({
	standalone: true,
	selector: 'g-printfile-report-message',
	templateUrl: './printfile-report-message.component.html',
	styleUrls: ['./printfile-report-message.component.scss'],
	imports: [GetTextPipe, NgIf, NgFor],
})
export class PrintfileReportMessageComponent {
	@Input() report?: api.PrintfileReportDetailDto[];

	/** Fix typo in old report format... */
	getOccurrences(
		detail: api.PrintfileReportDetailDto | PrintfileReportDetail,
	): api.PrintfileReportDetailOccurrencesDto | undefined | null {
		if ('occurances' in detail) return detail.occurances as api.PrintfileReportDetailOccurrencesDto; // spell-checker:disable-line
		if ('occurrences' in detail) return detail.occurrences as api.PrintfileReportDetailOccurrencesDto;
	}
	/** Return plural number for page range for translations. */
	getPlural(pages: string): number {
		if (!pages) return 0;
		if (pages.includes('-') || pages.includes(',')) return 2;
		return 1;
	}
}
